var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0815 34.135C40.7052 34.135 39.5898 33.1008 39.5898 31.8248V22.1755C39.5898 20.8994 40.7052 19.8652 42.0815 19.8652C43.4577 19.8652 44.5731 20.8994 44.5731 22.1755V31.8248C44.5731 33.1008 43.4577 34.135 42.0815 34.135Z",
    fill: "url(#paint0_linear_2683_332852)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9467 38.2783C14.3229 38.2783 15.4383 37.2441 15.4383 35.9681V18.0309C15.4383 16.7549 14.3229 15.7207 12.9467 15.7207C11.5705 15.7207 10.4551 16.7549 10.4551 18.0309V35.9689C10.4551 37.2441 11.5705 38.2783 12.9467 38.2783Z",
    fill: "url(#paint1_linear_2683_332852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49161 31.7989C3.86783 31.7989 4.98321 30.7647 4.98321 29.4887V24.5114C4.98321 23.2354 3.86783 22.2012 2.49161 22.2012C1.11539 22.2012 0 23.2354 0 24.5114V29.4887C0 30.7647 1.11539 31.7989 2.49161 31.7989Z",
    fill: "url(#paint2_linear_2683_332852)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1202 7.82358H31.3459C30.184 7.82358 29.2419 8.6971 29.2419 9.77441V13.5163C29.2419 14.5166 28.3673 15.3267 27.2893 15.3267C26.2104 15.3267 25.3367 14.5158 25.3367 13.5163V2.3626C25.3367 1.10179 24.2706 0.0337762 22.9108 0.000797219C21.5045 -0.0330274 20.3535 1.01384 20.3535 2.31017V51.6374C20.3535 52.8982 21.4197 53.9662 22.7795 53.9992C24.1858 54.033 25.3367 52.9862 25.3367 51.6898V40.4837C25.3367 39.4834 26.2113 38.6733 27.2893 38.6733C28.3682 38.6733 29.2419 39.4842 29.2419 40.4837V44.2256C29.2419 45.3029 30.184 46.1764 31.3459 46.1764H32.1202C33.2821 46.1764 34.2242 45.3029 34.2242 44.2256V9.77526C34.2242 8.6971 33.2821 7.82358 32.1202 7.82358ZM29.5365 33.1083C29.5365 33.9928 28.7631 34.7107 27.8083 34.7107C26.8543 34.7107 26.08 33.9937 26.08 33.1083V20.3277C26.08 19.4432 26.8534 18.7252 27.8083 18.7252C28.7622 18.7252 29.5365 19.4423 29.5365 20.3277V33.1083Z",
    fill: "url(#paint3_linear_2683_332852)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3492 28.5301C53.2606 27.6851 53.2606 26.3149 52.3492 25.4699C51.4378 24.6248 49.9601 24.6248 49.0487 25.4699C48.1373 26.3149 48.1373 27.6851 49.0487 28.5301C49.9601 29.3752 51.4378 29.3752 52.3492 28.5301Z",
    fill: "url(#paint4_linear_2683_332852)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2683_332852",
    x1: 41.5213,
    y1: 8.14366,
    x2: 55.8972,
    y2: 15.2034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466146,
    stopColor: "#95BEFB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B8C4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2683_332852",
    x1: 12.3866,
    y1: -2.80877,
    x2: 28.6589,
    y2: 2.24627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466146,
    stopColor: "#95BEFB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B8C4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2683_332852",
    x1: 1.93148,
    y1: 14.3173,
    x2: 13.5699,
    y2: 22.8149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466146,
    stopColor: "#95BEFB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B8C4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2683_332852",
    x1: 25.7298,
    y1: -44.3571,
    x2: 69.6628,
    y2: -28.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466146,
    stopColor: "#95BEFB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B8C4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2683_332852",
    x1: 45.9666,
    y1: 23.3001,
    x2: 55.4739,
    y2: 25.0312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466146,
    stopColor: "#95BEFB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B8C4F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb9c5df58bd9fa145aafa870c0222102.svg";
export { ForwardRef as ReactComponent };